import React from 'react';
import { HeartHandshakeIcon } from 'lucide-react';
const links = [{
  label: 'Mentions légales',
  href: '#mentions-legales'
}, {
  label: 'Conditions générales de vente',
  href: '#cgv'
}, {
  label: 'Politique de confidentialité',
  href: '#confidentialite'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Footer() {
  return <footer className="w-full bg-pink-950 py-14 text-white md:py-16" data-id="element-70" data-mp="36ppkflxcu4bz">
      <div className="mx-auto w-full max-w-3xl px-5 text-center md:px-8" data-id="element-71" data-mp="3ug3efhzi2d97">
        <p className="inline-flex items-center gap-2.5 text-sm font-extrabold uppercase tracking-widest text-amber-300 md:text-base" data-id="element-72" data-mp="38h81hlebwon">
          <span className="h-3 w-3 rounded-full bg-pink-400 ring-4 ring-pink-400/20" aria-hidden="true" data-id="element-73" data-mp="3ldkep6r0ggr6" />
          Kit d’Animation Octobre Rose
        </p>

        <p className="mt-6 text-sm text-pink-200" data-id="element-74" data-mp="29y5frxf8retf">© 2026 — Tous droits réservés</p>

        <p className="mt-6 inline-flex items-center gap-2 rounded-xl bg-pink-900 px-4 py-2.5 text-sm font-semibold text-pink-100 ring-1 ring-pink-800" data-id="element-75" data-mp="2eyjqxoc534vo">
          <HeartHandshakeIcon className="h-4 w-4 shrink-0 text-amber-300" aria-hidden="true" data-id="element-76" data-mp="3lbmvdvr3pehh" />
          Besoin de soutien ? N’hésitez pas à vous tourner vers un professionnel de santé.
        </p>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-sm text-pink-100" data-id="element-77" data-mp="3v5n74ggw1hz6">
          {links.map(link => <li key={link.label} data-id="element-78" data-mp="828oa9xiabb9">
              <a href={link.href} className="transition-colors duration-150 ease-out hover:text-amber-300" data-id="element-79" data-mp="81flfk1o45ye">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 border-t border-pink-800 pt-6 text-xs leading-relaxed text-pink-200" data-id="element-80" data-mp="cu0geowb8p3i">
          Ce produit est destiné à l’information, à la sensibilisation et à l’animation. Il ne
          remplace pas un avis médical, psychologique ou l’accompagnement d’un professionnel de
          santé.
        </p>
      </div>
    </footer>;
}